module.exports = __webpack_public_path__ + "nc.6f060b3215a84a530662.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/nc.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/nc.svg
// module chunks = styles